module.exports = __webpack_public_path__ + "static/media/IMG_2197.61055fed.JPG";